/**
 * usePermissions — the single React hook for tier/caps/features/usage.
 *
 * Backed by a TanStack Query with a 30s stale time. After a billing action
 * completes, the caller should `queryClient.invalidateQueries(['permissions'])`
 * so the gated UI updates without a full page reload.
 */
import { useQuery } from '@tanstack/react-query';

import { api } from '@/lib/api';
import type { PermissionsResponse } from '@/lib/permissions';

export function usePermissions(enabled = true) {
  return useQuery({
    queryKey: ['permissions'],
    queryFn: () => api<PermissionsResponse>('/api/me/permissions'),
    staleTime: 30_000,
    enabled,
  });
}
